/** @jsx jsx */
import { css } from "@emotion/react";
import videoShape from '../images/LP-versar/stars.png'
import videoShapeMobile from '../images/LP-versar/stars-mobile.png'
import bgDepoimentos from '../images/LP-arabe/bg-depoimentos.svg'

export const depoimentosStyle = css`
  background-color: #F7FAF8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 108px 0;
  /* background-image: url(${videoShape});
  background-repeat: no-repeat; */
  background-size: cover;
  overflow: clip;
  scroll-margin-top: 70px;

  @media only screen and (max-width: 600px) {
    padding: 60px 0; 
  }

  img {
    width: 100%;
    margin-bottom: 24px;
  }

  @media (max-width: 850px) {
    background-image: none;
  }

  .title-sec {
    margin-bottom: 56px;
    h2 {
    color: #3C3C3C;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    width: 100%;
    max-width: 416px;
    span {
      color: #F26F33;
      font-weight: 600;
    }
  }

  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0px;
  }
  }
  
  video {
    max-width: 1100px;
    @media (max-width: 850px) {
        max-width: 343px;
      margin-bottom: 100px;
    }
  }

  .video-institutional {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .title-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      color: #375F92;
      text-align: center;
      font-size: 40px;
      font-weight: 700;
      line-height: 100%;
      letter-spacing: -0.8px;
      margin-bottom: 24px;
    }
    p {
      
      color: #666;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
      max-width: 920px;

      @media (max-width: 850px) {
        max-width: 335px;
      }
    }
  }

  .text-container {
    display: flex;
    justify-content: center;
    padding-block: 52px;
    
    @media (max-width: 850px) {
      background-image: url(${videoShapeMobile});
      background-repeat: no-repeat;
      background-size: cover;
    
      p {

        max-width: 343px !important;
      }
    }

    p {
      color:#375F92;
      font-size: 40px;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: -0.8px;
      max-width: 862px;
      .full-text {
        color: #8A588D;
        .socioemocional {
          color: #8A588D;
          font-size: 40px;
          font-weight: 800 !important;
          line-height: 120%;
          letter-spacing: -0.8px;
        }
      }
    }
  }

  .box-depoimento {
    /* background-image: url(${bgDepoimentos});
    background-repeat: no-repeat;
    background-size: cover; */
    border-radius: 56px;
    background: #DAE7DC;
    padding: 32px;
    img {
      margin-bottom: 16px;
    }
    h2 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%;
    }
    p {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
  }
`
